import React from "react";
import InputDateField from "components/Reports/Timps/inputdateField";
import { languageService } from "Language/language.service";
import { themeService } from "../../../theme/service/activeTheme.service";
import moment from "moment";
import { CRUDFunction } from "../../../reduxCURD/container";
import CustomForm from "../../../libraries/form";
import { HOSEntrySchema } from "./schema/hosSchema";
import { ValidationResponse, messageListPopulatorAndValidator } from "./validationResponse";
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { isSelfUser } from "../../../utils/utils";
class HosView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateRange: {
        from: new Date(moment().startOf("month")),
        today: new Date(moment().startOf("day")),
        to: new Date(moment().endOf("month")),
      },
      hosEntry: {},
      selectedHosEntry: null,

      openHosEntryForm: false,
      hosValidationMessageList: [],
      hosEntryValidated: false,
      openConfirmModel: false,
    };
    this.updateDateRange = this.updateDateRange.bind(this);
    this.onHosEditDelete = this.onHosEditDelete.bind(this);
    this.onHOSFilled = this.onHOSFilled.bind(this);
    this.handleHosEntryConfirmResponse = this.handleHosEntryConfirmResponse.bind(this);
  }
  updateDateRange(dateRange) {
    this.setState({
      dateRange: dateRange,
    });
    this.fetchDataFromServer(dateRange, this.props.user);
  }
  componentDidMount() {
    this.fetchDataFromServer(this.state.dateRange, this.props.user);
  }

  fetchDataFromServer(range, user) {
    let userId = user ? user._id : "";
    let query = "?startDate=" + moment(range.from).format() + "&endDate=" + moment(range.to).format() + "&id=" + userId;
    this.props.getHosUsers("hos/" + userId + query);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.actionType !== prevProps.actionType && this.props.actionType == "HOSUSER_UPDATE_SUCCESS") {
      this.fetchDataFromServer(this.state.dateRange, this.props.user);
      this.setState({
        hosEntry: {},
        selectedHosEntry: null,
      });
    }
  }

  onHOSFilled(hosEntry) {
    if (hosEntry) {
      let hosEntryObj = {};
      if (this.state.selectedHosEntry) {
        hosEntryObj.id = this.state.selectedHosEntry.id;
        hosEntryObj.startTime = hosEntry.fields.startTime;
        hosEntryObj.startDate = hosEntry.fields.startTime;
        hosEntryObj.endDate = hosEntry.fields.endDate;
        hosEntryObj.comments = hosEntry.fields.comments;
        hosEntryObj.dateString = moment(hosEntry.fields.startTime).format().slice(0, 10);
      } else {
        hosEntryObj = hosEntry.fields;
        hosEntryObj.dateString = moment(hosEntry.fields.startDate).format().slice(0, 10);
      }
      let validator = messageListPopulatorAndValidator(hosEntryObj);
      this.setState({
        hosValidationMessageList: validator.messageList,
        hosEntryValidated: validator.pass,
        hosEntry: hosEntryObj,
      });
      if (validator.pass) {
        // open the confirmation dialog for hos entry
        let body = { ...hosEntryObj, email: this.props.user.email };
        this.props.updateHosUser(body, "/hos/web/" + this.props.user._id);
        this.setState({
          openHosEntryForm: false,
          hosValidationMessageList: [],
          hosEntryValidated: false,
        });
      }
    }
  }
  handleHosEntryConfirmResponse(response) {
    if (response && this.state.toDelSession) {
      this.props.updateHosUser({ sessionId: this.state.toDelSession.sessionId }, "/hos/web/delete/" + this.state.toDelSession.dataId);
    }
    this.setState({
      openConfirmModel: false,
      toDelSession: null,
    });
  }

  onHosEditDelete(session, dataId, del) {
    if (del) {
      this.setState({ toDelSession: { sessionId: session.id, dataId: dataId }, openConfirmModel: true });
    } else {
      this.setState({
        hosEntry: {
          id: session.id,
          startDate: new Date(session.startTime),
          startTime: new Date(session.startTime),
          endDate: new Date(session.endTime),
          comments: session.comments,
        },
        selectedHosEntry: session,
        hosState: "edit",
        openHosEntryForm: true,
      });
    }
  }
  render() {
    let dayDataView =
      this.props.hosUsers &&
      this.props.hosUsers.map((dayData) => {
        return <UserDayView data={dayData} onHosEditDelete={this.onHosEditDelete} user={this.props.user} />;
      });
    let customComp = <ValidationResponse hosValidationMessages={this.state.hosValidationMessageList} />;
    return (
      <div>
        <label className="lbl-fro-date">{languageService("Select a Date Range")}</label>
        {isSelfUser(this.props.user) && (
          <div style={{ float: "right" }}>
            <MyButton
              customStyle={{ margin: 0 }}
              onClick={(e) => this.setState({ openHosEntryForm: true, hosState: "create", hosEntry: {}, selectedHosEntry: null })}
            >
              {languageService("Add Duty Time")}
            </MyButton>
          </div>
        )}
        <span className="placeholder-for-date">
          <InputDateField updateDateRange={this.updateDateRange} defaultDate={this.state.dateRange} />
        </span>

        {this.state.openHosEntryForm && (
          <CustomForm
            mode="dialog"
            fieldsData={this.state.hosEntry}
            currState={this.state.hosState}
            formSchema={HOSEntrySchema}
            closeDialog={() => this.setState({ openHosEntryForm: false, hosEntry: {}, hosValidationMessageList: [] })}
            parentRef={{
              onHOSFilled: this.onHOSFilled,
              //GetEquipmentTypeFormFields: (type) => GetEquipmentTypeFormFields(equipmentTypes, type),
            }}
            customComponentBottom={customComp}
          />
        )}
        <div style={{ height: "65vh", overflow: "auto" }}>{dayDataView}</div>
        <ConfirmationDialog
          handleResponse={this.handleHosEntryConfirmResponse}
          modal={this.state.openConfirmModel}
          toggle={() => this.setState({ openConfirmModel: !this.state.openConfirmModel })}
          headerText="Confirm deletion"
          confirmationMessage="Are you sure you want to delete?"
        />
      </div>
    );
  }
}
const HosUserContainer = CRUDFunction(HosView, "hosUser", null, null, null, "users");
export default HosUserContainer;

const UserDayView = (props) => {
  let duration = 0;
  let min = "";
  let headingDay = props.data && props.data.date && moment(props.data.date).format("ddd Do MMM YYYY");
  let dataId = props.data && props.data._id;
  let sortedData =
    props.data && props.data.data
      ? props.data.data.sort((a, b) => moment(a.startTime).format("YYYYMMDDHHMMSS") - moment(b.startTime).format("YYYYMMDDHHMMSS"))
      : [];
  let dataView = sortedData.map((session) => {
    session.dur && (duration = duration + session.dur);
    let dur = session.dur ? Math.floor(session.dur / 60) : "";
    var minutes = session.dur ? Math.round(session.dur % 60) : "";
    return (
      <tr>
        <td>{checkIfDateOtherwiseString(session.startTime)} </td>
        <td>{checkIfDateOtherwiseString(session.endTime)} </td>
        <td>{dur + (minutes ? ":" + minutes : ":00")} </td>
        <td className="hos-thead-comments">{session.comments} </td>
        {isSelfUser(props.user) && (
          <td>
            <span style={{ cursor: "pointer" }} onClick={(e) => props.onHosEditDelete && props.onHosEditDelete(session, dataId)}>
              Edit
            </span>
            <span
              onClick={(e) => props.onHosEditDelete && props.onHosEditDelete(session, dataId, true)}
              style={{ marginLeft: "10px", cursor: "pointer" }}
            >
              Delete
            </span>
          </td>
        )}
      </tr>
    );
  });
  if (duration > 0) {
    min = Math.round(duration % 60);
  }
  if (duration > 0) duration = Math.floor(duration / 60);

  return (
    <div className="hos-panel">
      <div className="hos-title">
        <span style={{ marginLeft: "10px" }}>{headingDay}</span>
        <span style={{ float: "right", marginRight: "10px" }}>{"Duration  : " + duration + (min ? ":" + min : ":00") + " hours"}</span>
      </div>
      {dataView && dataView.length > 0 && (
        <table className="table table-bordered table-hover table-sm">
          <thead className="thead-light">
            <tr>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Duration Hours</th>
              <th className="hos-thead-comments">Comments</th>
              {isSelfUser(props.user) && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>{dataView}</tbody>
        </table>
      )}
    </div>
  );
};

function checkIfDateOtherwiseString(value) {
  let date = moment(value).isValid();
  if (date) {
    return moment(value).format("HH:mm");
  } else {
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/components/User/HOS/hosView.jsx